import PropTypes from 'prop-types';
import budgetImage from '@/components/common/icons/budget.svg';
import { cn } from '@/lib/utils';
import classes from './style.module.scss';
import Spinner from '@/components/common/Spinner/Spinner';
import CurrencyInput from '@/components/common/Form/CurrencyInput';
import Select from 'react-select';
import { useIntl } from 'react-intl';

const RepairBudgetFormComponent = ({
  busy,
  cancel,
  clientPanel,
  currentRoom,
  currentTag,
  filterTag,
  data,
  handleInputChange,
  handleRoomChange,
  handleTagChange,
  isLoading,
  onSubmit,
  options,
  optionsTag,
  roomsWithDamages,
}) => {
  const intl = useIntl();

  return isLoading ? (
    <div
      className={cn(
        classes.repairBudgetForm,
        'flex flex-col items-center justify-center min-h-[400px]',
        clientPanel && classes.isClientPanel
      )}
    >
      <Spinner />
    </div>
  ) : (
    <div className={cn(classes.repairBudgetForm, clientPanel && classes.isClientPanel)}>
      <div className={classes.card}>
        <h2 className={classes.cardHead}>
          <div className={classes.icon}>
            <img src={budgetImage} alt={intl.formatMessage({ id: 'DETAILS' })} />
          </div>
          {intl.formatMessage({ id: 'REPAIRS' })}
        </h2>

        <div className={cn(classes.field, classes.isFlex, classes.headActions)}>
          <div className={cn(classes.field, classes.is4)}>
            <label>{intl.formatMessage({ id: 'display' })}</label>
            <Select
              className={classes.select}
              classNamePrefix="select"
              placeholder={`${intl.formatMessage({ id: 'SELECT_AN_OPTION_MESSAGE' })}...`}
              value={optionsTag?.find(option => option.value === currentTag || '')}
              noOptionsMessage={() => intl.formatMessage({ id: 'NO_OPTIONS_AVAILABLE_MESSAGE' })}
              options={optionsTag}
              onChange={handleTagChange}
            />
          </div>
          <div className={cn(classes.field, classes.is8)}>
            <label>{intl.formatMessage({ id: 'selectLocation' })}</label>
            <Select
              className={classes.select}
              classNamePrefix="select"
              placeholder={`${intl.formatMessage({ id: 'SELECT_AN_OPTION_MESSAGE' })}...`}
              noOptionsMessage={() => intl.formatMessage({ id: 'NO_OPTIONS_AVAILABLE_MESSAGE' })}
              options={options}
              onChange={handleRoomChange}
            />
          </div>
        </div>

        {currentRoom ? (
          <div className={classes.damageList}>
            {(filterTag?.length
              ? currentRoom?.value === -1
                ? data?.damages?.find(i => filterTag?.some(r => i?.tags?.includes(r)))
                : roomsWithDamages[currentRoom.value]?.damages?.find(i => filterTag?.some(r => i?.tags?.includes(r)))
              : true) && <h3>{currentRoom.label}</h3>}

            <div className={classes.damageList}>
              {currentRoom.value === -1 ? (
                data.damages.map((damage, damageIndex) => {
                  if (filterTag?.length && !(damage?.tags && filterTag?.some(r => damage?.tags?.includes(r))))
                    return null;

                  return (
                    <div className={classes.damage} key={`room-damage-G-${damageIndex}`}>
                      <label>{intl.formatMessage({ id: 'DESCRIPTION' })}</label>
                      <p>{damage.description}</p>
                      <div className={cn(classes.field, classes.isFlex)}>
                        <div className={cn(classes.field, classes.is9)}>
                          <label htmlFor={`observation-G-G-${damageIndex}`}>
                            {intl.formatMessage({ id: 'NOTES_FROM_ADMINISTRATOR' })}
                          </label>
                          <textarea
                            name={`observation-G-G-${damageIndex}`}
                            id={`observation-G-G-${damageIndex}`}
                            value={damage.repairBudget ? damage.repairBudget.observation : ''}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className={cn(classes.field, classes.is3)}>
                          <label htmlFor={`price-G-G-${damageIndex}`}>
                            {intl.formatMessage({ id: 'REPAIR_VALUE' })}
                          </label>
                          <CurrencyInput
                            type="text"
                            name={`price-G-G-${damageIndex}`}
                            id={`price-G-G-${damageIndex}`}
                            value={damage.repairBudget ? damage.repairBudget.price : ''}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  {roomsWithDamages[currentRoom.value]?.damages?.map((damage, damageIndex) => {
                    if (filterTag?.length && !(damage?.tags && filterTag?.some(r => damage?.tags?.includes(r))))
                      return null;

                    return (
                      <div className={classes.damage} key={`room-damage-${currentRoom.value}-${damageIndex}`}>
                        <label>{intl.formatMessage({ id: 'DESCRIPTION' })}</label>
                        <p>{damage.description}</p>
                        <div className={cn(classes.field, classes.isFlex)}>
                          <div className={cn(classes.field, classes.is9)}>
                            <label htmlFor={`observation-${currentRoom.value}-R-${damageIndex}`}>
                              {intl.formatMessage({ id: 'NOTES_FROM_ADMINISTRATOR' })}
                            </label>
                            <textarea
                              name={`observation-${currentRoom.value}-R-${damageIndex}`}
                              id={`observation-${currentRoom.value}-R-${damageIndex}`}
                              value={damage.repairBudget ? damage.repairBudget.observation : ''}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className={cn(classes.field, classes.is3)}>
                            <label htmlFor={`price-${currentRoom.value}-R-${damageIndex}`}>
                              {intl.formatMessage({ id: 'REPAIR_VALUE' })}
                            </label>
                            <CurrencyInput
                              type="text"
                              name={`price-${currentRoom.value}-R-${damageIndex}`}
                              id={`price-${currentRoom.value}-R-${damageIndex}`}
                              value={damage.repairBudget ? damage.repairBudget.price : ''}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {roomsWithDamages[currentRoom.value]?.items?.map((item, itemIndex) => {
                    if (!item?.damages || !item.damages.length) return null;
                    if (filterTag?.length && !item.damages.find(i => filterTag.some(r => i?.tags?.includes(r))))
                      return null;

                    return (
                      <div className={classes.room} key={`room-item-${currentRoom.value}-${itemIndex}`}>
                        {!!(filterTag?.length
                          ? item?.damages?.find(i => filterTag?.some(r => i?.tags?.includes(r)))
                          : item?.damages?.length) && (
                          <h3>{`${+currentRoom.value + 1}.${itemIndex + 1} ${item.name}`}</h3>
                        )}

                        <div className={classes.damageList}>
                          {item.damages.map((damage, damageIndex) => {
                            if (filterTag?.length && !(damage?.tags && filterTag?.some(r => damage?.tags?.includes(r))))
                              return null;

                            return (
                              <div
                                className={classes.damage}
                                key={`item-damage-${currentRoom.value}-${itemIndex}-${damageIndex}`}
                              >
                                <label>{intl.formatMessage({ id: 'DESCRIPTION' })}</label>
                                <p>{damage.description}</p>
                                <div className={cn(classes.field, classes.isFlex)}>
                                  <div className={cn(classes.field, classes.is9)}>
                                    <label htmlFor={`observation-${currentRoom.value}-${itemIndex}-${damageIndex}`}>
                                      {intl.formatMessage({ id: 'NOTES_FROM_ADMINISTRATOR' })}
                                    </label>
                                    <textarea
                                      name={`observation-${currentRoom.value}-${itemIndex}-${damageIndex}`}
                                      id={`observation-${currentRoom.value}-${itemIndex}-${damageIndex}`}
                                      value={damage.repairBudget ? damage.repairBudget.observation : ''}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                  <div className={cn(classes.field, classes.is3)}>
                                    <label htmlFor={`price-${currentRoom.value}-${itemIndex}-${damageIndex}`}>
                                      {intl.formatMessage({ id: 'REPAIR_VALUE' })}
                                    </label>
                                    <CurrencyInput
                                      type="text"
                                      name={`price-${currentRoom.value}-${itemIndex}-${damageIndex}`}
                                      id={`price-${currentRoom.value}-${itemIndex}-${damageIndex}`}
                                      value={damage.repairBudget ? damage.repairBudget.price : ''}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        ) : (
          <p className={cn(classes.isCentered, classes.borderTop)}>{intl.formatMessage({ id: 'selectRoom' })}</p>
        )}

        <div className={classes.cardFooter}>
          <button type="button" className={classes.button} disabled={busy} onClick={cancel}>
            {intl.formatMessage({ id: 'CANCEL' })}
          </button>
          <button type="submit" className={cn(classes.button, classes.isGreen)} disabled={busy} onClick={onSubmit}>
            {intl.formatMessage({ id: 'SAVE' })}
          </button>
        </div>
      </div>
    </div>
  );
};

RepairBudgetFormComponent.propTypes = {
  busy: PropTypes.bool,
  cancel: PropTypes.func,
  clientPanel: PropTypes.bool,
  currentRoom: PropTypes.object,
  filterTag: PropTypes.array,
  currentTag: PropTypes.string,
  data: PropTypes.object,
  handleInputChange: PropTypes.func,
  handleRoomChange: PropTypes.func,
  handleTagChange: PropTypes.func,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
  options: PropTypes.array,
  optionsTag: PropTypes.array,
  roomsWithDamages: PropTypes.object,
};

export default RepairBudgetFormComponent;
